import config from '../config/server-config';
// import { history } from '../utils/navigation-util';
import { API_CALL_SUCCESSFULL } from '../constants/NumberConstants';
import api from '../api';

export const getdata_FAQS_definition = async (res) => {
  try {
    const response = await api.post(
      config.getdata_FAQS_definition,
      {
        ProductID: res.ProductID,
        AdditionalSectionID: res.AdditionalSectionID
      }
    );
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export default getdata_FAQS_definition;
